const config = {
  selectedUrl: ''
};

const ajaxCall = async (): Promise<void> => {
  try {
    const response = await fetch(config.selectedUrl);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const wrap = document.querySelector('.js-contentModal .cc-modal__dialog')!;

    wrap.innerHTML = await response.text();
  } catch (error) {
    console.error('Could not fetch Content Modal', error);
  }
};

const init = (selectedUrl: string): void => {
  config.selectedUrl = selectedUrl;

  ajaxCall();
};

export { init };
